import {
  PMSmallNumber,
  PMSmallNumberCardEditSchema,
} from "@pimo/pimo-components/src/lib/pm-components";

import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addNumberOfProjectsDueCard(ctx: DashboardCardContext) {
  const { view, getCardCopy } = ctx;

  const numberOfProjectsDueComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "numberOfProjectsDueComponent",
      title: "",
      description: "",
      labels: ["#ofProjectsDue"],
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  numberOfProjectsDueComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "numberOfProjectsDueComponent",
      labels: ["#ofProjectsDue"],
      description: getCardCopy(language, "dueProjects").description,
      title: getCardCopy(language, "dueProjects").title,
      editSchema: PMSmallNumberCardEditSchema,
    };
  });

  numberOfProjectsDueComponent.mapState(({ dashboard, language }) => {
    return {
      title: getCardCopy(language, "dueProjects").title,
      number: dashboard?._calculated?.numberOfOverdueProjects ?? 0,
    };
  });

  numberOfProjectsDueComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "endDate", "projectBasic")
  );
}
